import React from "react";
import { NavLink } from "react-router-dom";
import './styles.css';
function SubTabsWeather() {
    return (
      <div className="scrollable-container-app">
        <ul className="nav nav-tabs">
          <li className="nav-item">
            <NavLink to="/weather/daily" className="nav-link" activeClassName="active" 
            style={{ height: "28px", fontSize: "12px", textAlign: "center" }}
            >
              Daily Weather
            </NavLink>
          </li>
        </ul>
      </div>
    );
  }
  
  export default SubTabsWeather;